export default __webpack_public_path__ + "assets/images/coins-54225a3bc9db34490e0c3721ef45205e.svg";